import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import i18n from 'util/i18n';

import { totalSections, completedSections } from 'helpers/navigation';

import { isPVQForm } from 'helpers/form';
import styles from './ScoreCard.module.scss';

export var ScoreCard = function ({ total, completed, formType }) {
  const scoreCardClasses = classnames(styles.ScoreCard, 'score-card', {
    [`${styles.completed}`]: completed >= total,
  });

  const textClasses = classnames(styles.text, 'score-card-text');

  const isPvq = isPVQForm(formType);
  return (
    <div className={scoreCardClasses}>
      <span className="score-card-done">{completed}</span>
      <span aria-label="of">/</span>
      <span className="score-card-total">{total}</span>
      <span className={textClasses}>{i18n.t(isPvq ? 'scorecard.pvqComplete' : 'scorecard.complete')}</span>
    </div>
  );
};

ScoreCard.propTypes = {
  total: PropTypes.number,
  completed: PropTypes.number,
  formType: PropTypes.string,
};

ScoreCard.defaultProps = {
  total: 10,
  completed: 0,
  formType: '',
};

const mapStateToProps = (state) => ({
  total: totalSections(state),
  completed: completedSections(state),
  formType: state.application?.Settings?.formType,
});

export default connect(mapStateToProps)(ScoreCard);
